import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { createRoot } from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import materialUITheme from '@redact/materialUITheme';
import SnackbarCustom from '@common-components/Snackbar';
import configureAppStore from '@redact-state/configureStore';
import { helpers } from '@veritone/glc-redux';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import UserOnboardingRoot from '@user-onboarding/components/UserOnboardingRoot';
// Load external/global CSS
import '@resources/styles/veritone-icon.css';
import '@resources/styles/veritone-engines.css';
import '@resources/styles/common-global.scss';
import '@resources/styles/redact-global.scss';
import 'video-react/dist/video-react.css';

const styleNode = document.createComment('jss-insertion-point');
if (document.head) {
  document.head.insertBefore(styleNode, document.head.firstChild);
}

const store = configureAppStore();

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

const { handleImplicitRedirect } = helpers;

/* Bootstrap the necessary dependencies into your React app */
export function bootstrap(Application: ReactNode, element: string) {
  if (window.name === '_auth') {
    /* If this is an OAuth redirect window, deal with the OAuth response */
    return handleImplicitRedirect(window.location.hash, window.opener);
  }

  const container = document.getElementById(element);
  // TODO: Can we justify the use of ! here?
  const root = createRoot(container!);
  root.render(
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={materialUITheme}>
        <Provider store={store}>
          <SnackbarProvider
            autoHideDuration={5000}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            {Application}
            <ToastContainer />
            <UserOnboardingRoot />
            <SnackbarCustom />
          </SnackbarProvider>
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
